/**
 * Decodifica (sin verificar firma) el payload de un JWT HS256 para extraer
 * los claims `tenant` y `chat_id`. La verificación real la hace el backend;
 * aquí solo leemos los claims para armar el topic STOMP.
 */
export interface ContactTokenClaims {
  tenant?: string;
  contacto_id?: string;
  chat_id?: string;
  type?: string;
  exp?: number;
  [k: string]: unknown;
}

function base64UrlDecode(input: string): string {
  let b64 = input.replace(/-/g, '+').replace(/_/g, '/');
  const pad = b64.length % 4;
  if (pad) b64 += '='.repeat(4 - pad);
  // atob -> bytes latin1; decodificamos como UTF-8 para soportar acentos.
  const binary = atob(b64);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder('utf-8').decode(bytes);
}

export function decodeJwtClaims(token: string): ContactTokenClaims {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return {};
    return JSON.parse(base64UrlDecode(parts[1])) as ContactTokenClaims;
  } catch {
    return {};
  }
}
